import React, { useEffect, useRef, useState } from "react";

const CustomCursor = () => {
  const [particles, setParticles] = useState([]);
  const last = useRef(0);
  const id = useRef(0);
  useEffect(() => {
    const precisePointer = window.matchMedia(
      "(hover: hover) and (pointer: fine)",
    );
    if (!precisePointer.matches) return undefined;

    const move = (event) => {
      if (Date.now() - last.current < 85) return;
      last.current = Date.now();
      const particle = { id: id.current++, x: event.clientX, y: event.clientY };
      setParticles((current) => [...current.slice(-7), particle]);
      window.setTimeout(
        () =>
          setParticles((current) =>
            current.filter((item) => item.id !== particle.id),
          ),
        720,
      );
    };
    window.addEventListener("pointermove", move, { passive: true });
    return () => window.removeEventListener("pointermove", move);
  }, []);
  return (
    <div className="pointer-trail" aria-hidden="true">
      {particles.map((particle) => (
        <span key={particle.id} style={{ left: particle.x, top: particle.y }} />
      ))}
    </div>
  );
};
export default CustomCursor;
